// @flow

import React, { Component } from 'react';
import Switch from 'react-router-dom/Switch';
import Route from 'react-router-dom/Route';
import sizeMe from 'react-sizeme';

import ProductDrawer from './ProductDrawer/ProductDrawer';
import ArticleDrawer from './ArticleDrawer/ArticleDrawer';
import ProductsDrawer from './ProductsDrawer/ProductsDrawer';
import ArticlesDrawer from './ArticlesDrawer/ArticlesDrawer';

type Props = {
  onHeightChanged: Function,
  size: {
    height: number,
  }
}

class BottomDrawer extends Component<void, Props, void> {
  componentWillReceiveProps(nextProps: Props) {
    if (this.props.size.height !== nextProps.size.height) {
      this.props.onHeightChanged(nextProps.size.height);
    }
  }

  render() {
    return (
      <div>
        <Switch>
          <Route
            path="/products/:id"
            render={matchProps => <ProductDrawer {...matchProps} />}
          />
          <Route
            path="/articles/:id"
            render={matchProps => <ArticleDrawer {...matchProps} />}
          />
          <Route
            path="/doctor/:id"
            render={matchProps => <ProductsDrawer {...matchProps} />}
          />
          <Route
            path="/patient/:id"
            render={matchProps => <ArticlesDrawer {...matchProps} />}
          />
        </Switch>
      </div>
    )
  }
}

export default sizeMe({ monitorHeight: true })(BottomDrawer);



// WEBPACK FOOTER //
// ./src/components/BottomDrawer.js